import React  from "react";
import * as Icon from "react-feather";
import BASE from "../configs/BASE";
import Product from "../assets/img/rover_icon/Product.svg";
import crm from "../assets/img/rover_icon/crm.svg";
import accounts from "../assets/img/rover_icon/accounts.svg";
import stocks from "../assets/img/rover_icon/stocks.svg";
import employee from "../assets/img/rover_icon/employee.svg";
import settings from "../assets/img/rover_icon/settings.svg";
import userIcon from "../assets/img/rover_icon/user.svg";
 
import circle from "../assets/img/rover_icon/circle.svg";
import distribution from "../assets/img/rover_icon/distribution.svg";
import Sales from "../assets/img/rover_icon/marketing.svg";
import slack from "../assets/img/rover_icon/slack.png";
 

 
const divStyle = {
  marginRight: "10px",
  width: "25px",
  height: "25px",
};
const circleStyle = {
  marginRight: "10px",
  width: "15px",
  height: "15px",
};
const reportStyle = {
  marginRight: "10px",
  width: "15px",
  height: "15px",
  background: "green",
};

const getAuth = (id) => {
  let status = "";
  let permissionroles = {};
  let authenticatedUser = localStorage.getItem("user");
  if (authenticatedUser) {
    let user = JSON.parse(authenticatedUser);
    if (user && user.auth && user.auth.isAuth) {
      permissionroles = user.perRol;
      permissionroles.map((item) => {
        if (id == item.s_cod) {
          status = item.acc;
        }
      });
    }
  }
  return status;
};
//let Img = <img src={userImage}/>

const navigationConfig = [
  {
    id: "home",
    title: "Dashboard",
    type: "item",
    icon: <Icon.Home size={20} />,
    permissions: getAuth("home"),
    navLink: getAuth("home") ? "/home" : "/home2",
  },
  {
    id: "slrpt",
    title: "Sales Reports",
    type: "collapse",
    icon: <i className="feather icon-aperture" />,
    children: [
      {
        id: "slamt",
        title: " Sales Memo",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("slamt"),
        navLink: "/slamt",
      },
      {
        id: "slrmt",
        title: " Return Memo",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("slrmt"),
        navLink: "/slrmt",
      },
      {
        id: "rcamt",
        title: "Collection Target",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("rcamt"),
        navLink: "/rcamt",
      },
      {
        id: "depo",
        title: "Deposit Report",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("depo"),
        navLink: "/depo",
      },
      {
        id: "prlgr",
        title: "Party Ledger",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("prlgr"),
        navLink: "/prlgr",
      },
      {
        id: "slsum",
        title: "Sales Summary",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("slsum"),
        navLink: "/slsum",
      },
      {
        id: "slrpt",
        title: "Party Balance Report",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("slrpt"),
        navLink: "/slrpt",
      },
      {
        id: "prnetsal",
        title: "Product Net Sales",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("prnetsal"),
        navLink: "/prnetsal",
      },
      {
        id: "psld",
        title: "Sales Memo Details",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("psld"),
        navLink: "/psld",
      },
      {
        id: "cusbal",
        title: "Party Balance",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("cusbal"),
        navLink: "/cusbal",
      },
      {
        id: "slpf",
        title: "Profit In Sales",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("slpf"),
        navLink: "/slpf",
      },
      {
        id: "mnpf",
        title: "Profit by Publisher's",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("mnpf"),
        navLink: "/mnpf",
      },
      {
        id: "blrpt",
        title: "Book List Report",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("blrpt"),
        navLink: "/blrpt",
      },
      {
        id: "blre",
        title: "Tentative Sales By Book list",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("blre"),
        navLink: "/blre",
      },
      {
        id: "sprpt",
        title: "Specimen Report",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("blre"),
        navLink: "/sprpt",
      },
      {
        id: "demsa",
        title: "Deamarcation Sales Analysis",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("demsa"),
        navLink: "/demsa",
      },
    ],
  },
  {
    id: "sel",
    title: "Sales",
    type: getAuth("sel") ? "collapse" : "item",
    icon: <img src={Sales} style={divStyle} alt="" />,
    permissions: getAuth("sel"),

    children: [
      {
        id: "csal",
        title: "Retail",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("csal"),

        navLink: "/csal",
      },
      {
        id: "cslgr",
        title: "Customer",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("cslgr"),
        navLink: "/cslgr",
      },

      {
        id: "chal",
        title: "Whole Sales",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("chal"),

        navLink: "/chal",
      },
      {
        id: "squot",
        title: "New Quotation",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("squot"),

        navLink: "/squot",
      },

      {
        id: "qtsls",
        title: "Quotation List",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("qtsls"),

        navLink: "/qtsls",
      },

      {
        id: "retn",
        title: "Sales Return",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("retn"),

        navLink: "/retn",
      },

      {
        id: "spsal",
        title: "Specimen Copy",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("spsal"),

        navLink: "/spsal",
      },
      {
        id: "recvs",
        title: "Money Receive",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("recvs"),

        navLink: "/recvs",
      },
      {
        id: "anbcl",
        title: "Annually Closing",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("anbcl"),

        navLink: "/anbcl",
      },

      {
        id: "curin",
        title: "Curier Info",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("curin"),
        navLink: "/curin",
      },

      {
        id: "curbo",
        title: "Curier Booking",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("curbo"),

        navLink: "/curbo",
      },
      {
        id: "ordr",
        title: "Order",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("ordr"),

        navLink: "/ordr",
      },

      {
        id: "ortr",
        title: "Order Tracking",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("ortr"),

        navLink: "/ortr",
      },

      {
        id: "canc",
        title: "Cancel",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("canc"),

        navLink: "/canc",
      },
    ],
  },
  {
    id: "pcrpt",
    title: "Purchase Reports",
    type: "collapse",
    icon: <i className="feather icon-aperture" />,
    children: [
      {
        id: "pcamt",
        title: " Purchase Memo",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("pcamt"),
        navLink: "/pcamt",
      },
      {
        id: "pcrmt",
        title: " Purchase Returm Memo",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("pcrmt"),
        navLink: "/pcrmt",
      },  
          {
        id: "pcrmt",
        title: " Supplier Net Qty",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("pcrmt"),
        navLink: "/supnpq",
      },
      {
        id: "cprpt",
        title: " Payment Vouchers",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("cprpt"),
        navLink: "/cprpt",
      },
      {
        id: "cmlgr",
        title: "Supplier Ledger",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("cmlgr"),
        navLink: "/cmlgr",
      },
      {
        id: "pcsum",
        title: "Supplier Summary",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("pcsum"),
        navLink: "/pcsum",
      },

    ],
  },
  {
    id: "pur",
    title: "Purchase",
    type: getAuth("pur") ? "collapse" : "item",
    icon: <img src={distribution} style={divStyle} alt="" />,
    permissions: getAuth("pur"),
    children: [
      {
        id: "suplgr",
        title: "Supplier",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("suplgr"),
        navLink: "/suplgr",
      },
      {
        id: "purc",
        title: "New Purchase",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("purc"),
        navLink: "/purc",
      },
      {
        id: "prnt",
        title: "Purchase Return",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("prnt"),
        navLink: "/prnt",
      },

      {
        id: "strc",
        title: "Store Requisition",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("strc"),
        navLink: "/strc",
      },

      {
        id: "stmv",
        title: "Stock Movement",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("stmv"),
        navLink: "/stmv",
      },

      {
        id: "prec",
        title: "Products Receive",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("prec"),

        navLink: "/prec",
      },
      {
        id: "deag",
        title: "Delivery Agent",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("deag"),

        navLink: "/deag",
      },
      {
        id: "degt",
        title: "Delivery Agent Type",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("degt"),

        navLink: "/degt",
      },
      {
        id: "agch",
        title: "Agent Charge",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("agch"),

        navLink: "/agch",
      },
      {
        id: "deen",
        title: "Delivery Entry",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("deen"),

        navLink: "/deen",
      },

      {
        id: "debl",
        title: "Delivery Bill",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("debl"),

        navLink: "/debl",
      },
      {
        id: "shcc",
        title: "Shipping Charge Costing",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("shcc"),

        navLink: "/shcc",
      },

      {
        id: "bill",
        title: "Bill",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("bill"),

        navLink: "/bill",
      },

      {
        id: "clim",
        title: "Claim",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("clim"),

        navLink: "/clim",
      },
      {
        id: "courec",
        title: "Courier Receive",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("courec"),

        navLink: "/courec",
      },
    ],
  },

  {
    id: "crm",
    title: "CRM",
    type: getAuth("crm") ? "collapse" : "item",
    icon: <img src={crm} style={divStyle} alt="" />,
    permissions: getAuth("crm"),
    children: [
      {
        id: "scho",
        title: "School",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("scho"),

        navLink: "/scho",
      },
      {
        id: "cuin",
        title: "Customer Info",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("cuin"),

        navLink: "/cuin",
      },

      {
        id: "cudm",
        title: "Customer Data Management",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("cudm"),

        navLink: "/cudm",
      },
      {
        id: "noti",
        title: "Notification",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("noti"),

        navLink: "/noti",
      },

      {
        id: "demr",
        title: "Demarcation",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("demr"),

        navLink: "/demr",
      },
      {
        id: "nodt",
        title: "Notification Details",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("nodt"),

        navLink: "/nodt",
      },
      {
        id: "oftp",
        title: "Offer Type",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("oftp"),

        navLink: "/oftp",
      },

      {
        id: "offr",
        title: "Offer",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("offr"),

        navLink: "/offr",
      },
      {
        id: "ofdt",
        title: "Offer Details",
        type: "item",
        icon: <img src={circle} style={circleStyle} />,
        permissions: getAuth("ofdt"),

        navLink: "/ofdt",
      },
    ],
  },
   {
    id: "prorpt",
    title: "Product Reports",
    type: "collapse",
    icon: <i className="feather icon-aperture" />,
    children: [
         {
        id: "prlst",
        title: "Product List",
        type: "item",
       icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("prlst"),

        navLink: "/prlst",
      },
            {
        id: "stsum",
        title: "Stock Summary",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("stsum"),
        navLink: "/stsum",
      },
      {
        id: "stmvr",
        title: "Stock Movement",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("stmvr"),
        navLink: "/stmvr",
      },

    ],
  },

  {
    id: "pro",
    title: "Products",
    type: getAuth("pro") ? "collapse" : "item",
    icon: <img src={Product} style={divStyle} alt="" />,
    permissions: getAuth("pro"),
    children: [
   
      {
        id: "prge",
        title: BASE.prge,
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("prge"),

        navLink: "/prge",
      },
      {
        id: "prbr",
        title: BASE.prbr,
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("prbr"),

        navLink: "/prbr",
      },
      {
        id: "prca",
        title: BASE.prca,
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("prca"),
        navLink: "/prca",
      },
      {
        id: "prvn",
        title: BASE.prvn,
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("prvn"),
        navLink: "/prvn",
      },
      {
        id: "film",
        title: "Filter Master",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("film"),

        navLink: "/film",
      },
      {
        id: "fivl",
        title: "Filter Value ",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("fivl"),

        navLink: "/fivl",
      },
      {
        id: "psku",
        title: BASE.psku,
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("psku"),
        navLink: "/psku",
      },
      {
        id: "pskt",
        title: BASE.pskt,
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("pskt"),
        navLink: "/pskt",
      },

      {
        id: "pmanut",
        title: BASE.pmanut,
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("pmanut"),

        navLink: "/pmanut",
      },
      {
        id: "blst",
        title: "Booklist",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("blst"),
        navLink: "/blst",
      },
      {
        id: "prfl",
        title: "Product Filter",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("prfl"),
        navLink: "/prfl",
      },
      {
        id: "unit",
        title: "Unit",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("unit"),

        navLink: "/unit",
      },

      // {
      //   id: "uncn",
      //   title: "Unit Conversion",
      //   type: "item",
      //   icon: <img src={circle} style={circleStyle} alt="" />,
      //   permissions: getAuth("uncn"),

      //   navLink: "/uncn",
      // },
      {
        id: "prra",
        title: "Product Rate",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("prra"),

        navLink: "/prra",
      },
      {
        id: "bonst",
        title: "Bonus Setup",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("bonst"),

        navLink: "/bonst",
      },
      {
        id: "filen",
        title: "Add From Excel",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("filen"),
        navLink: "/filen",
      },
      {
        id: "filup",
        title: "Update From Excel",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("filup"),
        navLink: "/filup",
      },

      {
        id: "bomd",
        title: "BOM",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("bomd"),
        navLink: "/bomd",
      },
      {
        id: "brco",
        title: "Barcode",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("brco"),
        navLink: "/brco",
      },
      {
        id: "bach",
        title: "Batch",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("bach"),
        navLink: "/bach",
      },
      {
        id: "stra",
        title: "Standard Rate",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("stra"),
        navLink: "/stra",
      },
            {
        id: "stor",
        title: "Store",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("stor"),
        navLink: "/stor",
      },

        {
        id: "phst",
        title: "Current Stock",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("phst"),
        navLink: "/phst",
      },                                 
    ],
  },
  {
    id: "accrpt",
    title: " Account Reports",
    type: "collapse",
    icon: <i className="feather icon-aperture" />,

    children: [
      {
        id: "lgtrn",
        title: "Ledger Transaction",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("lgtrn"),
        navLink: "/lgtrn",
      },
      {
        id: "lgsum",
        title: "Group Summary",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("lgsum"),
        navLink: "/lgsum",
      },
      {
        id: "bsrpt",
        title: "Balance Sheet",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("bsrpt"),
        navLink: "/bsrpt",
      },
      {
        id: "plrpt",
        title: "Profit & Loss",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("plrpt"),
        navLink: "/plrpt",
      },
      {
        id: "tbrpt",
        title: "Trial Balance",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("tbrpt"),
        navLink: "/tbrpt",
      },
      {
        id: "dbrpt",
        title: "Day Book",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("dbrpt"),
        navLink: "/dbrpt",
      },
      {
        id: "cfrpt",
        title: "Cash Flow",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("cfrpt"),
        navLink: "/cfrpt",
      },
      {
        id: "casrept",
        title: "Cash Register",
        type: "item",
        icon: <img src={slack} style={circleStyle} alt="" />,
        permissions: getAuth("casrept"),
        navLink: "/casrept",
      },
    ],
  },
  {
    id: "acc",
    title: "Accounts",
    type: getAuth("acc") ? "collapse" : "item",
    icon: <img src={accounts} style={divStyle} alt="" />,
    permissions: getAuth("acc"),
    children: [
      {
        id: "acgr",
        title: "Account Group",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("acgr"),
        navLink: "/acgr",
      },
      {
        id: "ledg",
        title: "Legder",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("ledg"),

        navLink: "/ledg",
      },

      {
        id: "crlmt",
        title: "Credit Limit",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("crlmt"),

        navLink: "/crlmt",
      },
      {
        id: "vctp",
        title: "Voucher Type",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("vctp"),

        navLink: "/vctp",
      },
      {
        id: "fiyr",
        title: "Financial Year",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("fiyr"),

        navLink: "/fiyr",
      },
      {
        id: "revc",
        title: "Receipt Voucher",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("revc"),

        navLink: "/revc",
      },
      {
        id: "pavc",
        title: "Payment Voucher",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("pavc"),
        navLink: "/pavc",
      },
      {
        id: "jovc",
        title: "Journal Voucher",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("jovc"),

        navLink: "/jovc",
      },

      {
        id: "cnvc",
        title: "Contra Voucher",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("cnvc"),

        navLink: "/cnvc",
      },
      {
        id: "offxsh",
        title: "Office Expense",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("offxsh"),

        navLink: "/offxsh",
      },
      {
        id: "casreg",
        title: "Cash Register",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("casreg"),

        navLink: "/casreg",
      },
      // {
      //   id: "adaw",
      //   title: "Daily Wages",
      //   type: "item",
      //   icon: <img src={circle} style={circleStyle} alt="" />,
      //   permissions: getAuth("adaw"),

      //   navLink: "/adaw",
      // },
      {
        id: "amsa",
        title: "Monthly Salary",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("amsa"),

        navLink: "/amsa",
      },
      // {
      //   id: "adva",
      //   title: "Advance Payment",
      //   type: "item",
      //   icon: <img src={circle} style={circleStyle} alt="" />,
      //   permissions: getAuth("adva"),

      //   navLink: "/adva",
      // },

      {
        id: "bnre",
        title: "Bank Reconciliation",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("bnre"),

        navLink: "/bnre",
      },
      {
        id: "curr",
        title: "Currency",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("curr"),

        navLink: "/curr",
      },
      {
        id: "cucn",
        title: "Currency Convertion",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("cucn"),

        navLink: "/cucn",
      },
      {
        id: "vttp",
        title: "Vat Types",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("vttp"),

        navLink: "/vttp",
      },
      {
        id: "taxs",
        title: "Tax",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("taxs"),

        navLink: "/taxs",
      },

      {
        id: "pbtx",
        title: "Purchase Bill Tax",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("pbtx"),

        navLink: "/pbtx",
      },

      {
        id: "prtx",
        title: "Purchase Return Tax",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("prtx"),

        navLink: "/prtx",
      },
    ],
  },
  {
    id: "hrm",
    title: "HRM",
    type: getAuth("hrm") ? "collapse" : "item",
    icon: <img src={employee} style={divStyle} alt="" />,
    permissions: getAuth("hrm"),
    children: [
      {
        id: "emtp",
        title: "Type",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("emtp"),

        navLink: "/emtp",
      },
      {
        id: "dept",
        title: "Department",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("dept"),

        navLink: "/dept",
      },
      {
        id: "dign",
        title: "Designation",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("dign"),

        navLink: "/dign",
      },
      {
        id: "emin",
        title: "Employee Info",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("emin"),

        navLink: "/emin",
      },
      {
        id: "emsc",
        title: "Schedule",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("emsc"),

        navLink: "/emsc",
      },

      {
        id: "epsc",
        title: "Employee Schedule",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("epsc"),

        navLink: "/epsc",
      },
      {
        id: "lems",
        title: "Leave Master",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("lems"),

        navLink: "/lems",
      },
      {
        id: "lset",
        title: "Employee Leave Setings",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("lset"),
        navLink: "/lset",
      },
      {
        id: "hode",
        title: "Holiday Declaration",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("hode"),
        navLink: "/hode",
      },

      {
        id: "hose",
        title: "Holiday Setup",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("hose"),
        navLink: "/hose",
      },
      {
        id: "aten",
        title: "Attendance",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("aten"),

        navLink: "/aten",
      },
      {
        id: "leap",
        title: "Leave Approved",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("leap"),

        navLink: "/leap",
      },
      {
        id: "pahe",
        title: "Pay Head",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("pahe"),

        navLink: "/pahe",
      },
      {
        id: "sapk",
        title: "Salary Package",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("sapk"),

        navLink: "/sapk",
      },
      {
        id: "sade",
        title: "Salary Detail",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("sade"),

        navLink: "/sade",
      },
      {
        id: "dawa",
        title: "Daily Wages",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("dawa"),

        navLink: "/dawa",
      },
      {
        id: "bode",
        title: "Bonus Deduction",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("bode"),

        navLink: "/bode",
      },
      {
        id: "mosa",
        title: "Monthly Salary",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("mosa"),

        navLink: "/mosa",
      },
    ],
  },
  {
    id: "usr",
    title: "Users",
    type: getAuth("usr") ? "collapse" : "item",
    icon: <img src={userIcon} style={divStyle} alt="" />,
    permissions: getAuth("usr"),
    children: [
      {
        id: "perm",
        title: "Role",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("perm"),

        navLink: "/perm",
      },
      {
        id: "uspr",
        title: "Role Permission",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("uspr"),

        navLink: "/uspr",
      },
      {
        id: "usin",
        title: "User",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("usin"),

        navLink: "/usin",
      },
      {
        id: "vnot",
        title: "Voice Note",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("vnot"),

        navLink: "/vnot",
      },
    ],
  },

  {
    id: "recov",
    title: "Change Log",
    type: getAuth("recov") ? "collapse" : "item",
    icon: <img src={settings} style={divStyle} alt="" />,
    permissions: getAuth("recov"),
    children: [
      {
        id: "rsals",
        title: "Invoice ",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("rsals"),

        navLink: "/rsals",
      },
      {
        id: "rsret",
        title: "Return",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("rsret"),
        navLink: "/rsret",
      },
      {
        id: "rpurc",
        title: "Purchase",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("rpurc"),
        navLink: "/rpurc",
      },
      {
        id: "rpret",
        title: "Purchase Return",
        type: "item",
        icon: <img src={circle} style={circleStyle} alt="" />,
        permissions: getAuth("rpret"),
        navLink: "/rpret",
      },
    ],
  },
];

export default navigationConfig;
